// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__8CHVI","active":"Nav_active__-FVWx"};